// Token rotativo de sessão (janela de 30s, TTL ~10min)
export function makeToken(sessionId: string) {
  const w = Math.floor(Date.now() / 30000);
  let h = 5381;
  const s = sessionId + w;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) + h) ^ s.charCodeAt(i);
    h = h >>> 0;
  }
  return sessionId + "-" + w + "-" + String(h % 1000000).padStart(6, "0");
}

export function tokenValid(token: string) {
  const parts = token.split("-");
  parts.pop();
  const w = parseInt(parts.pop()!, 10);
  const now = Math.floor(Date.now() / 30000);
  return now >= w && now <= w + 20;
}

export function sessionFromToken(token: string) {
  const parts = token.split("-");
  parts.pop();
  parts.pop();
  return parts.join("-");
}
